module.exports = __webpack_public_path__ + "static/media/TV-off-image-4.b4fbd6b4.jpg";